import { MDBIcon } from "mdb-react-ui-kit";
import { useContext } from 'react';
import useResumeExperiencesHandlers from "../../../context/resume/hooks/resume-experiences-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";

export default function AddExperience( { insertionIndex, experienceOrders } ) {

    const { translations } = useContext( TranslationContext );
    const { handleAdd } = useResumeExperiencesHandlers();

    return (
        <button className="btn_primary" onClick={ () => handleAdd( insertionIndex, experienceOrders ) }>
            <MDBIcon fas
                     icon="plus-circle"
                     color='light'
                     size='sm'
                     title={ translations.experiencesSection.addExperienceLabel }
            />
            <span className='ms-1'>{ translations.experiencesSection.addExperienceLabel }</span>
        </button>
    )
}
